import {
  CreateQuestionInput,
  CreateQuestionMutation,
  DeleteQuestionInput,
  DeleteQuestionMutation,
  ModelQuestionConnection,
  Question,
  QuestionsByInstrumentQuery,
  QuestionsByInstrumentQueryVariables
} from "../../API";
import { genericQuery, listQueryAutoPaginated } from "../api/apiUtils";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";

export const deleteQuestion = async (id: string) => {
  const predicate = { input: { id: id } };
  return await genericQuery<DeleteQuestionMutation, Question>(
    mutations.deleteQuestion,
    "deleteQuestion",
    predicate
  );
};

export const createQuestion = async (input: CreateQuestionInput) => {
  const predicate = { input: input };
  return await genericQuery<CreateQuestionMutation, Question>(
    mutations.createQuestion,
    "createQuestion",
    predicate
  );
};

export const fetchQuestionsByInstrument = async (instrumentId: string) => {
  const variables: QuestionsByInstrumentQueryVariables = {
    instrumentId: instrumentId,
    filter: {
      or: [
        { deletedAt: { eq: null } },
        { deletedAt: { attributeExists: false } }
      ]
    }
  };
  return await listQueryAutoPaginated<
    QuestionsByInstrumentQuery,
    Question,
    ModelQuestionConnection
  >(queries.questionsByInstrument, "questionsByInstrument", "items", variables);
};
